import { Injectable } from '@angular/core';
import { sharedConfig } from 'src/environments/shared-config';
import { UserInfoService } from '../auth-service/user-info-service';
import { SecureStorageService } from '../secure-storage/secure-storage-service';
import { SecureStorageKey } from '../storage/models/secure-storage-key.enum';
import { SessionService } from '../session-service/session-service';

@Injectable({
  providedIn: 'root',
})
export class AppVersionGuardService {
  constructor(private sessionService: SessionService) {}

  /**
   * Persists the running app version. When the stored version is missing or differs,
   * logs the user out (after saving any in-progress treatment) so sessions start fresh.
   * @returns true when logout was initiated
   */
  async ensureVersionAndLogoutIfChanged(): Promise<boolean> {
    const currentVersion = this.getCurrentVersionKey();
    const storedVersion = await SecureStorageService.getById<string>(
      SecureStorageKey.LastKnownAppVersion,
    );

    if (storedVersion === currentVersion) {
      return false;
    }

    // Save before logout so the post-redirect load does not loop.
    await SecureStorageService.save(SecureStorageKey.LastKnownAppVersion, currentVersion);

    const userInfo = await UserInfoService.getUserInfo();
    if (!userInfo) {
      return false;
    }

    await this.sessionService.logoutPersistingCurrentTreatment('app version change', {
      triggerTimeoutHandlers: false,
    });
    return true;
  }

  private getCurrentVersionKey(): string {
    return `${sharedConfig.version}|${sharedConfig.build}`;
  }
}
